export default __webpack_public_path__ + "static/media/blackslider3.f7eb8380.png";